import * as PIXI from 'pixi.js';
import Layers from "slotworks/graphics/layers/layers";
import { Signal } from "signals";
import Timer from "slotworks/utils/timer";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";

import Rectangle from "slotworks/utils/geom/rectangle";
import deviceInfo from "slotworks/utils/device-info";
import { CenterPivot } from 'slotworks/graphics/pixi/group';
import { Ungroup } from "slotworks/graphics/pixi/group";
import soundManager from 'slotworks/sound/sound-manager';
import WheelPlaque from './wheel-plaque';
import gameState from 'slotworks/model/game-state';
import WheelBonusRecord from 'integration/records/wheel-bonus-record';

export default class WheelAnimated {

    public static SPACE_BETWEEN: number = 30;

    public static MIN_REPEATS: number = 1;

    public static SPEED: number = 1 / 100;

    public static MIN_SPEED: number = 1 / 800;

    public static START_SPEED: number = 1 / 300;

    public static DECELERATE_SPEED = -0.00004;

    public static DECELERATE_MIDDLE_SPEED = -0.00002;

    public static ACCELERATE_SPEED = 0.0000025;

    public static VERTICES_ALONG_Y = 100;

    public static MIN_SPEED_MOTION = -0.00001; // fix for bigger time interval between frames, cant use lerp    

    public onComplete: Signal = new Signal();
    public onReady: Signal = new Signal();

    private plaques: WheelPlaque[];
    private seconds: WheelPlaque[];
    private positions: number[] = [];
    private progress: number;

    private indexesToWin: number = -1;


    private offset: number = 8; // offset between plaques

    private winKey: string;
    private winIndex: number;

    private top: number;
    private bottom: number;

    private lastTime: number;

    private tickTimer: number;

    private repeats: number;
    private layer: Layers;

    private winPosition: number;
    private distanceToWin: number;

    private renderTexture: PIXI.RenderTexture;
    private renderContainer: PIXI.Container;
    private renderPlane: PIXI.SimplePlane;
    private indexInParent: number;

    private topY: number;
    private bottomY: number;
    private scaleDifference: number;

    private totalDistance: number;

    private wheelContainer: PIXI.Container;

    private bonusContainerY: number;

    // moving the wheel in texture
    private animating: boolean;
    private wheelHeight: number;

    private activePlaque: WheelPlaque = null;

    private wheelPosition: Rectangle;

    private static KEYS: string[] = ["20", "30", "40", "50", "80", "100", "200", "250", "500", "750", "1000", "1500"];

    constructor() {
        this.layer = Layers.Bonus;
        this.plaques = [];
        this.seconds = [];
        for (let key of WheelAnimated.KEYS) {
            let name: string = key;

            // const item = this.layer.getSprite("Wedge_" + name);
            // this.plaques.push(item);
            // item.visible = false;

            const item = new WheelPlaque(key);
            this.plaques.push(item);
            this.layer.container.addChildAt(item, 1);
            // // create plaque(key)

            // const plaque2 = new PIXI.Sprite(item.texture);
            // this.layer.container.addChildAt(plaque2, 2);
            // plaque2.position.set(item.x, item.y);
            // plaque2.visible = false;
            // plaque2.name = name;

            // this.seconds.push(plaque2);
        }
        //    if(canvasManager.orientation === Orientation.PORTRAIT) {
        // this.plaques.push(...this.seconds);
        //    }
        this.setToPositions();
        this.init();
        this.show().then(() => this.onReady.dispatch());
        this.startTick();
    }

    public restart() {
        this.show().then(() => this.onReady.dispatch());
    }

    private init() {
        const background = this.layer.getSprite("wheel_strip_bg");
        const dark_top = this.layer.getSprite("wheel_darkgrad_top");
        dark_top.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        const dark_bottom = this.layer.getSprite("wheel_darkgrad");
        dark_bottom.blendMode = PIXI.BLEND_MODES.MULTIPLY;
        const light = this.layer.getSprite("wheel_lightgrad");
        light.blendMode = PIXI.BLEND_MODES.MULTIPLY;

        const backgroundPosition = this.layer.getPosition("wheel_strip_bg");
        const wheelPosition = deviceInfo.isDesktop ? backgroundPosition : this.layer.getPosition("wheel");
        this.wheelPosition = this.layer.localToGlobal(wheelPosition);
        
        this.scaleDifference = (background.height - wheelPosition.height) / 2;
        
        this.renderTexture = PIXI.RenderTexture.create({ width: background.width + 30, height: background.height });
        
        this.renderContainer = new PIXI.Container();

        this.renderPlane = new PIXI.SimplePlane(this.renderTexture, 2, WheelAnimated.VERTICES_ALONG_Y);
        this.renderPlane.x = 0;
        this.renderPlane.y = 0//this.scaleDifference;

        const parent = this.layer.container.parent;
        this.indexInParent = parent.getChildIndex(this.layer.container)
        this.layer.container.x = 0;
        this.renderContainer.addChild(this.layer.container);

        this.wheelContainer = new PIXI.Container();
        this.wheelContainer.addChild(this.renderPlane);
        parent.addChildAt(this.wheelContainer, this.indexInParent);

        this.bonusContainerY = -background.y// -(backgroundPosition.y - background.y);
        this.layer.container.y = this.bonusContainerY;
        canvasManager.renderer.render(this.renderContainer, this.renderTexture);

        // const points = this.bezier(-50, 0, 50, canvasManager.stageHeight / 2, -50, canvasManager.stageHeight, WheelAnimated.VERTICES_ALONG_Y);
        // const points = this.bezier(-100, 0, 60, canvasManager.stageHeight / 2, -100, canvasManager.stageHeight, WheelAnimated.VERTICES_ALONG_Y);
        const points = this.bezier(-100, 0, 130, wheelPosition.height / 2, -100, wheelPosition.height, WheelAnimated.VERTICES_ALONG_Y);

        this.reshape(points.xpoints, points.ypoints);


        this.renderPlane.textureUpdated = () => { }
        
        this.wheelContainer.x = this.wheelPosition.x;// (canvasManager.stageWidth - this.wheelContainer.width) / 2 + this.wheelContainer.parent.x;
        this.wheelContainer.y = this.wheelPosition.y;
        
        if (!deviceInfo.isDesktop) {
            this.onOrientationChange();

            deviceInfo.onLayoutChange.add(this.onLayoutChange);
        }

    }

    public onLayoutChange = () => {
        // setTimeout(() => {
        //     const positionBg = this.layer.getPosition("wheel_strip_bg");
        //     const wheelPosition = this.layer.getPosition("wheel");
        //     const background = this.layer.getSprite("wheel_strip_bg");
        //     const backgroundTransform = new Rectangle(background.x, background.y, background.width, background.height);
        //     this.scaleDifference = (background.height - backgroundTransform.height) / 2;
        //     background.y -= this.scaleDifference;
        //     this.renderTexture.resize(background.width + 30, background.height);
        //     this.renderPlane.x = 0;
        //     this.renderPlane.height = background.height;
        //     this.renderPlane.width = background.width + 30;

        //     this.renderPlane.y = 0;//(canvasManager.stageHeight - this.renderPlane.height) / 2;
        //     this.layer.container.x = 0;

        //     this.layer.container.y = -background.y;
        //     this.bonusContainerY = background.height;

        //     this.bonusContainerY = -background.y;

        //     const scale = canvasManager.stageHeight / this.renderPlane.height;
        //     this.wheelContainer.scale.set(scale, scale);

        //     this.wheelContainer.x = (canvasManager.stageWidth - this.wheelContainer.width) / 2 + this.wheelContainer.parent.x;
        //     this.wheelContainer.y = this.wheelContainer.parent.toLocal(new PIXI.Point(0, 0)).y;

        //     this.onOrientationChange();

        //     this.updatePlaques();

        //     canvasManager.renderer.render(this.renderContainer, this.renderTexture);
        // }, 10);
    }

    public onOrientationChange() {
        this.layer.container.x = 0;
        this.layer.container.y = this.bonusContainerY;
        const wheelPosition = this.layer.getPosition("wheel");
        // if (canvasManager.orientation == Orientation.PORTRAIT) {
        //     if (deviceInfo.layoutMain == "mobile") {
        //         this.wheelContainer.x = (canvasManager.stageWidth - width) / 2 - this.wheelContainer.parent.x;
        //     } else
        //         this.wheelContainer.x = (canvasManager.stageWidth - this.wheelContainer.width) / 2 - this.wheelContainer.parent.x;
        // } else {
        //     this.wheelContainer.x = (canvasManager.stageWidth - this.wheelContainer.width) / 2 - this.wheelContainer.parent.x;
        // }
        this.wheelContainer.x = this.wheelPosition.x;
        this.wheelContainer.y = this.wheelPosition.y;
    }

    private show(): Contract<void> {
        return new Contract(resolve => {
            setTimeout(() => resolve(null), 100);
        });
    }

    private easeIn(t: number, b: number, c: number, d: number) {
        t /= d;
        return c * t * t + b;
    }

    private easeOut(t: number, b: number, c: number, d: number) {
        t /= d;
        return -c * t * (t - 2) + b;
    }

    private redistribute(points: number[], strength = 1): number[] {
        const result: number[] = [];
        const n = points.length;
    
        const min = points[0];
        const max = points[n - 1];
    
        for (let i = 0; i < n; i++) {
            let t = i / (n - 1);
    
            // mirror easing from both sides
            let eased = t < 0.5
                ? 0.5 * Math.pow(t * 2, strength)
                : 1 - 0.5 * Math.pow((1 - t) * 2, strength);
    
            result.push(min + (max - min) * eased);
        }
    
        return result;
    }

    private reshape(points: number[], ypoints: number[]) {
        const c = this.renderPlane.verticesBuffer.data as Float32Array;
        const vertices: number[] = new Array(c.length);
        for (let i = 0; i < c.length; i++)
            vertices[i] = c[i];
        for (let i = 0; i < points.length; i++) {
            vertices[i * 4] -= points[i];
            vertices[i * 4 + 1] = ypoints[i];
            vertices[i * 4 + 2] += points[i];
            vertices[i * 4 + 3] = ypoints[i];
        }

        this.renderPlane.verticesBuffer.update(new Float32Array(vertices));
    }

    private bezier(
        startX: number, startY: number,
        middleX: number, middleY: number,
        endX: number, endY: number,
        steps: number
    ) {
        const xpoints: number[] = [];
        const ypoints: number[] = [];
    
        const rawY: number[] = [];
    
        // --- First pass: compute normal bezier Y ---
        for (let i = 0; i <= steps; i++) {
            const t = i / steps;
    
            const a = (1 - t) * (1 - t);
            const b = 2 * t * (1 - t);
            const c = t * t;
    
            const y = a * startY + b * middleY + c * endY;
            rawY.push(y);
        }
    
        // normalize Y to 0..1
        const minY = Math.min(...rawY);
        const maxY = Math.max(...rawY);
        const rangeY = maxY - minY || 1;

        const strength = deviceInfo.isDesktop ? 1.3 : 2.3;
        // --- redistribute Y (cluster ends) ---
        for (let i = 0; i <= steps; i++) {
            let t = (rawY[i] - minY) / rangeY;
    
            // symmetric edge clustering
            
            let eased = t < 0.5
                ? 0.5 * Math.pow(t * 2, strength)
                : 1 - 0.5 * Math.pow((1 - t) * 2, strength);
    
            const redistributedY = minY + eased * rangeY;
            ypoints.push(redistributedY);
    
            // use redistributed Y as new parameter for X
            const a = (1 - eased) * (1 - eased);
            const b = 2 * eased * (1 - eased);
            const c = eased * eased;
    
            const x = a * startX + b * middleX + c * endX;
            xpoints.push(x);
        }
    
        return { xpoints, ypoints };
    }

    public start() {
        this.animating = true;
        this.lastTime = Timer.time;
        this.repeats = 0;        
    }

    private currentDistance: number = 0;
    public setWinner(key: string) {
        this.winKey = key;
        this.winIndex = WheelAnimated.KEYS.findIndex(el => el === this.winKey);

        if (this.winIndex < 0) {
            throw new Error("Wrong index key " + key);
        }

        const winPosition = this.positions[this.winIndex];        

        const obj = { value: this.currentDistance % this.wheelHeight };

        new TweenJS.Tween(obj)
            .to({ value: obj.value + 200 }, 600)
            .delay(600)
            .onUpdate(() => this.updateNew(obj.value))
            .easing(TweenJS.Easing.Cubic.InOut)
            .onComplete(() => {
                soundManager.customEvent("wheel_spin");
                new TweenJS.Tween(obj)
                    // .to({ value: - this.wheelHeight * 3 - winPosition + this.positions[4] - this.plaques[this.winIndex].heightInner/2 - this.plaques[4].heightInner}, 8000)
                    .to({ value: - this.wheelHeight * 2  + this.positions[4] - winPosition - this.plaques[this.winIndex].heightInner*2/3 }, 6000)
                    .delay(200)
                    .onUpdate(() => this.updateNew(obj.value))
                    .easing(TweenJS.Easing.Sinusoidal.Out)
                    .onComplete(() => {
                        this.finish();
                    })
                    .start();
            }).start();
    }

    private calculatePositions() {
        let current = 0;
        for (let i = 0; i < this.plaques.length; i++) {
            const plaque = this.plaques[i];
            plaque.y = current;
            plaque.visible = true;
            this.positions[i] = plaque.y;
            current += plaque.heightInner + this.offset;
        }
        this.wheelHeight = current;
    }

    private updatePlaques() {
        for (let i = 0; i < this.positions.length; i++) {
            const plaque = this.plaques[i];
            plaque.visible = true;
            plaque.y = this.positions[i] + this.progress * this.offset;
        }
    }

    private setToPositions() {
        this.calculatePositions();
        this.progress = 0;

        this.top = 0;
        this.bottom = this.plaques.length - 1;

        this.updateNew(this.plaques[4].heightInner/2 - this.offset * 4);
    }

    private updateNew(distance: number) {
        this.currentDistance = distance;
        const mid = this.wheelHeight/4 + 100;
        for (let i = 0; i < this.plaques.length; i++) {
            const plaque = this.plaques[i];
            plaque.y = (this.positions[i] + distance) % this.wheelHeight;
            if(plaque.y < 0) {
                plaque.y += this.wheelHeight;
                // soundManager.customEvent("wheel_spin_notch");
            }
            if(plaque.y < mid && plaque.y + plaque.heightInner > mid) {
                if(this.activePlaque != plaque) {
                    if(this.activePlaque) {
                        this.activePlaque.stop();
                    }
                    this.activePlaque = plaque;
                    this.activePlaque.anticipate();

                    soundManager.customEvent("wheel_spin_notch");
                }
            }
        }
    }

    private render() {
        canvasManager.renderer.render(this.renderContainer, this.renderTexture);
    }

    private finish() {
        soundManager.customEvent("wheel_stop");
        this.animating = false;
        this.showAnimation().then(() => {
            setTimeout(() => {
                const record = gameState.getCurrentGame().getCurrentRecord() as WheelBonusRecord;

                if(record.total == 1) {
                    soundManager.customEvent("wheel_prize");
                } else {
                    soundManager.customEvent("wheel_prize_meter");
                }
            }, 300);     
            setTimeout(() => {
                this.plaques[this.winIndex].stop();
                this.plaques[this.winIndex].anticipate();
                this.onComplete.dispatch();                
            }, 800); // 1300
        });
    }

    private startTick() {
        this.stopTick();
        this.tickTimer = Timer.setInterval(this.tick, 0);
    }

    private stopTick() {
        Timer.clearInterval(this.tickTimer);
    }

    private tick = () => {
        this.render();
    }

    private showAnimation(): Contract<void> {
        return this.plaques[this.winIndex].win();
    }

    public zoomOut() {
        // Layers.Prompts.moveBehind(Layers.Custom.get("BonusWheelFront"));
        return new Contract(resolve => {

            const winPlaque = this.plaques[this.winIndex];
            new TweenJS.Tween(winPlaque)
                .to({ alpha: 0 }, 300)
                .delay(200)
                .start();

            const center = CenterPivot(this.wheelContainer);
            new TweenJS.Tween(center.scale)
                .to({ x: 0, y: 0 }, 400)
                .onComplete(() => {
                    Ungroup(center);
                    resolve(null);
                })
                .start();
        });
    }

    public clean() {
        this.stopTick();
        for(let plaque of this.plaques) {
            plaque.clean();
        }
        deviceInfo.onLayoutChange.remove(this.onLayoutChange);
        // restore state and free resources
        this.wheelContainer.removeChild(this.renderPlane);
        this.layer.container.x = this.renderPlane.x;
        this.wheelContainer.parent.addChildAt(this.layer.container, this.indexInParent);
        this.wheelContainer.parent.removeChild(this.wheelContainer);
        this.renderPlane.destroy();
        this.renderTexture.destroy();
    }

}

